import {Inject, injectable} from 'inversify-props';

import {OsInfo} from '@/model/system/OsInfo';

import {IApiService} from '@/services/IApi.service';
import {ISystemOsService} from '@/services/system/IOs.service';
import {TypedJSON} from 'typedjson';

@injectable()
export class SystemOsService implements ISystemOsService {

  @Inject(Symbol.for('IApiService'))
  private apiService!: IApiService;

  private path: string = '/system/os';

  private osInfoSerializer = new TypedJSON(OsInfo);

  public async getInfo(): Promise<OsInfo> {
    return this.osInfoSerializer.parse(await this.apiService.get(this.path))!;
  }

  public async reboot(message?: string, delayMin: number = 0): Promise<void> {

    const args = {
      delayMin,
      message,
    };

    return this.apiService.post(`${this.path}/reboot`, args);
  }

  public async shutdown(message?: string, delayMin: number = 0): Promise<void> {

    const args = {
      delayMin,
      message,
    };

    return this.apiService.post(`${this.path}/shutdown`, args);
  }
}
